export const OVERRIDE_GUIDE_PATH = "override-guide";

export const OVERRIDE_GUIDE_LINK_LABEL = "Help";
